module.exports = __webpack_public_path__ + "media/images/partner/initiators/koeln_business-d5535003ee958f57f01c473ee6508047.png";